import { render } from "./EmployeeView.vue?vue&type=template&id=3b442341"
import script from "./EmployeeView.vue?vue&type=script&lang=js"
export * from "./EmployeeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__